import type { SpinResponse } from "@slot/client-engine";
import { MergeRoundBuilder } from "../../MergeRoundBuilder";
import { OFFLINE_ROUND } from "../offlineRound";
import { FREE_SPIN_SCRIPTS } from "./freeSpinScripts";

/** The bought session (`free_spins_buy`): the reveal lands three FS on a dead board, then the eight free spins. Pays 30.50. */
export function fsBonusBuy(): SpinResponse {
  return new MergeRoundBuilder({ roundId: "merge-bonus-buy", ...OFFLINE_ROUND })
    .baseSpin(
      {
        board: [
          ["L2", "H1", "L3", "L1", "H3", "L4"],
          ["L4", "FS", "H2", "L3", "L2", "H1"],
          ["H4", "L3", "L1", "L4", "FS", "L2"],
          ["L1", "L2", "H3", "L2", "L3", "L1"],
          ["H2", "L4", "FS", "H4", "L1", "H2"],
          ["L3", "H1", "L2", "L1", "L4", "L3"],
        ],
        refill: [[], [], [], [], [], []],
      },
      { freeSpins: { featureIdentifier: "free_spins_buy", spins: FREE_SPIN_SCRIPTS } },
    )
    .build();
}
